import { Trash2 } from "lucide-react";
import { TableCell, TableRow } from "./ui/table";
import { ResponseBadge } from "./ResponseBadge";
import { ConfirmDelete } from "./ConfirmDelete";
import { formatStamp } from "../lib/format";

const dash = <span className="text-slate-300">—</span>;

export const DoorRsvpRow = ({ guest: g, busy, onDelete }) => (
  <TableRow data-testid={`admin-door-row-${g.id}`}>
    <TableCell className="pl-5" />
    <TableCell className="whitespace-nowrap px-5 py-4 font-semibold text-slate-900">
      <span data-testid={`admin-door-name-${g.id}`}>{g.name}</span>
      {g.name !== g.identifier && <span data-testid={`admin-door-identifier-${g.id}`} className="block text-xs font-normal text-slate-500">{g.identifier}</span>}
      <span data-testid={`admin-door-source-${g.id}`} className="mt-1 inline-block rounded-full bg-slate-100 px-2 py-0.5 text-[11px] font-semibold uppercase tracking-[0.1em] text-slate-600">
        {g.source === "import" ? "Imported" : "Added manually"}
      </span>
    </TableCell>
    <TableCell className="px-5">{dash}</TableCell>
    <TableCell className="px-5">{dash}</TableCell>
    <TableCell className="px-5"><ResponseBadge value="yes" /></TableCell>
    <TableCell className="px-5 font-mono">0</TableCell>
    <TableCell className="px-5">{dash}</TableCell>
    <TableCell className="px-5">{dash}</TableCell>
    <TableCell className="whitespace-nowrap px-5 text-slate-500">{formatStamp(g.updated_at)}</TableCell>
    <TableCell className="pr-5 text-right">
      <ConfirmDelete testid={`admin-delete-door-${g.id}`} busy={busy} onConfirm={() => onDelete(g)} title={`Remove ${g.name} from the guest list?`}>
        <button data-testid={`admin-delete-door-btn-${g.id}`} title="Remove from guest list" className="inline-flex h-9 w-9 items-center justify-center rounded-lg text-slate-400 transition-[background-color,color] duration-200 hover:bg-red-50 hover:text-red-600">
          <Trash2 className="h-4 w-4" />
        </button>
      </ConfirmDelete>
    </TableCell>
  </TableRow>
);
